<template>
  <article class="">
    <section class="portada">
      <div class="linea">
        <h1>Sistema de Gestión Integrado</h1>
      </div>
    </section>
    <section class="lineas">
      <div class="linea1"></div>
      <div class="linea2"></div>
      <div class="linea3"></div>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p><strong>Compañía Mega S.A.</strong>, implementó un Sistema de Gestión certificado el 1 de noviembre de 2002 a través de una auditoría externa. Hoy acredita el cumplimiento de los requisitos de ISO 9001:2015 (Sistemas de Gestión de la Calidad), ISO 14001:2015(Sistemas de Gestión Ambiental) y OHSAS18001:2007 (Sistemas de Gestión de la Seguridad y Salud Ocupacional en el Trabajo), aplicables a su proceso de separación, transporte, fraccionamiento y almacenamiento de los componentes líquidos del gas natural, despacho y venta de productos.</p>
            <h5>La Implementación</h5>
            <p>La implementación de un Sistema Integrado de Gestión basado en las Normas ISO 9000-2000, ISO 14001-1996 e IRAM 3800-1998 fue un desafío para la Compañía, teniendo en cuenta las diferentes localizaciones, culturas y procesos operativos. Esto significó una optimización de los procesos y una mejora en los estándares de la Compañía.</p>
            <h5>La Política y el Manual de Gestión</h5>
            <p>La Política de Gestión de la Compañía se apoya en Principios de Dirección alineados con los compromisos de YPF, Dow y Petrobras con la Calidad, la Seguridad, la Salud y el Medio Ambiente. Por su esmero y dedicación en la calidad de su gestión, Compañía Mega obtuvo importantes premios.</p>
            <a href="static/pdf/politica.png" target="_blank"><i class="icon-file-pdf"></i><h5>VER POLITICA DE GESTIÓN</h5></a>
            <p>Como parte de este proceso la Compañía emitió su Manual de Gestión y realizó su comunicación formal en la Organización.</p>
            <div class="cont-pdf">
              <a href="static/pdf/Certificado-9001-2015.pdf" target="_blank"><img src="./certificado-9001-2015.jpg" alt="" class="pdf"></a>
              <a href="static/pdf/Certificado-14001-2015.pdf" target="_blank"><img src="./certificado-14001-2015.jpg" alt="" class="pdf"></a>
              <a href="static/pdf/Certificado-18001-2007.pdf" target="_blank"><img src="./certificado-18001-2007.jpg" alt="" class="pdf"></a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="secundario">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h2>Premio Nacional a la calidad 2006</h2>
            <p>Como consecuencia de su esmero y dedicación en la calidad de su gestión, Compañía Mega S.A. fue galardonada en el año 2006 con el Premio Nacional a la Calidad que distingue la excelencia en calidad de gestión. La entrega del premio se efectuó en un acto llevado a cabo en la Casa de Gobierno con la presencia del Sr. Presidente de la Nación, Néstor Kirchner, quien hiciera entrega del mismo.</p>
            <img src="./g-premio.jpg" alt="" class="img-fluid">
            <p>El Premio Nacional a la Calidad es un sistema de evaluación integrado, a partir de un modelo ideal de empresa de alta competencia, y es otorgado anualmente por la Nación Argentina a través del Presidente de la Nación. Asimismo, es organizado y administrado por la Fundación Premio Nacional a la Calidad, creada para ese fin.<p>
            <p>Fue instituido por la ley 24.127 en 1994, con el objetivo de promover el desarrollo de los procesos y sistemas destinados al mejoramiento continuo de la calidad en los productos y servicios, a fin de fomentar la modernización y competitividad del sector empresario.</p>
            <p>Pueden concursar pequeñas, medianas o grandes empresas, tanto de servicios como de producción de bienes, que tengan como mínimo una continuidad operativa de 3 años en el país.</p>
            <p>La evaluación de las organizaciones está a cargo de una junta de evaluadores compuesta por jueces y examinadores seleccionados por concurso abierto que actúa en forma independiente de la Fundación.<p>
            <p>Implica un riguroso proceso, que se extiende a lo largo de 4 meses y consta de 3 etapas bien diferenciadas: en la primera, un grupo no menor de 5 examinadores estudian en forma independiente las fortalezas y los aspectos a mejorar de los 28 criterios del premio, aplicables a cada postulante, y le asignan puntaje. En la segunda etapa, estos examinadores se reúnen para consensuar los resultados obtenidos para cada empresa. Por último, en la tercera etapa, las empresas seleccionadas reciben la visita del equipo de examinadores.</p>
            <p>Examinadores y jueces realizan esta tarea ad honorem y cada empresa evaluada insume en promedio 765 horas profesionales que se plasman en el informe de retroalimentación que reciben las empresas participantes, independientemente del resultado del concurso.</p>
            <p>El premio se instauró en el año 1992, y entre los ganadores se encuentran empresas de diferentes rubros y categorías tales como Unilever de Argentina S.A. (División Limpieza y Cuidado Personal), Hotel Intercontinental, Telecom Personal S.A., Nextel Argentina, 3M Argentina, Siderar, División Lubricantes de Repsol YPF, Taranto San Juan S.A. y Volkswagen Argentina Centro Industrial Córdoba, entre otras.</p>
            <a href="http://www.fundece.org.ar" target="_blank" class="link-azul">www.FUNDECE.org.ar</a>
          </div>
        </div>
      </div>
    </section>
    <section class="secundario">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h2>Premio Oro Iberoamericano a la calidad año 2008</h2>
            <p>El Premio Iberoamericano de la Calidad es un Programa Oficial de la Cumbre Iberoamericana de Jefes de Estado y de Gobierno, basado en el Modelo Iberoamericano de Excelencia en la Gestión y gestionado por FUNDIBEQ.</p>
            <img src="./fundibeq_premio.jpg" alt="" class="img-fluid">
            <p>Al Premio Iberoamericano de la Calidad pueden acceder las Organizaciones Iberoamericanas tanto públicas como privadas de Iberoamérica.</p>
            <p>Este Premio es desarrollado gracias a la colaboración de los Premios Nacionales y Regionales Asociados de los diferentes países de Iberoamérica y tiene por objeto:</p>
            <p>
              <ul>              
                <li>Reconocer la Calidad de las organizaciones premiadas en el contexto internacional y con ello contribuir a que la Comunidad Iberoamericana sea considerada un entorno de Calidad, donde encontrar los mejores proveedores, aliados y oportunidades de inversión.</li>
                <li>Estimular el desarrollo de las organizaciones iberoamericanas, ofreciendo un Modelo que permite compararse con organizaciones excelentes a nivel internacional.</li>
                <li>Promover la Auto-evaluación y la focalización hacia la satisfacción de las necesidades y expectativas del cliente y de las partes interesadas.</li>
              </ul>
            </p>
            <p>Compañía Mega S.A. fue galardonada en el año 2008 con el PREMIO ORO IBEROAMERICANO A LA CALIDAD, en la categoría PRIVADA MEDIANA. Esta premiación nos llena de orgullo y nos refuerza en nuestro constante compromiso con la calidad de toda nuestra gestión.</p>
            <a href="http://www.fundibeq.org" target="_blank" class="link-azul">www.FUNDIBEQ.org</a>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'sistemaDeGestion'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.secundario p 
  margin-bottom: 10px
.cont-pdf
  width: 100%
  display: flex
  justify-content: space-around
img 
  margin: 20px auto
.link-azul
  display: block
  text-align: center
  color: #004D9E
a h5 
  font-size: 14px
  margin: 0 0 15px 0
  display: inline-block

</style>



// WEBPACK FOOTER //
// src/components/sistema-de-gestion-en/sistemaDeGestion-en.vue